// Footer.jsx — visibile solo all'admin
import React, { useEffect, useState } from "react";
import { FaMapMarkerAlt, FaPhoneAlt, FaMobileAlt, FaWhatsapp, FaStar } from "react-icons/fa";
import { fetchRatingStats } from "../utility/EndPointGoogleFirebase";

const Footer = () => {
  const [averageRating, setAverageRating] = useState(0);
  const [totalReviews, setTotalReviews]   = useState(0);
  const [isLoading, setIsLoading]         = useState(true);

  useEffect(() => {
    fetchRatingStats()
      .then(s => { setAverageRating(s.averageRating); setTotalReviews(s.totalReviews); })
      .catch(() => { setAverageRating(5.0); setTotalReviews(0); })
      .finally(() => setIsLoading(false));
  }, []);
 
  const menuUrl     = "https://www.nuovoforno1966.it/menu";
  const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(`Ciao! Qui trovi il nostro menu: ${menuUrl} ⭐  Votaci, il tuo voto conta! ❤️`)}`;
  const mapsUrl     = "https://www.google.com/maps/search/?api=1&query=Via+Europa+35+89046+Marina+di+Gioiosa+Ionica";

  return (
    <>
      <style>{`
        .ft-root {
          background: #0f172a;
          color: #94a3b8;
          margin-top: auto;
        }
        @media (min-width: 768px) {
          .ft-root {
            margin-left: 220px;
          }
        }

        .ft-wrap {
          max-width: 860px; margin: 0 auto;
          padding: 28px 24px 20px;
        }

        /* Rating — sempre centrata */
        .ft-rating {
          display: flex; flex-direction: column; align-items: center;
          gap: 6px; text-align: center;
          padding-bottom: 22px;
          border-bottom: 1px solid #1e293b;
          margin-bottom: 22px;
        }
        .ft-rating-label {
          font-size: 10px; font-weight: 600; color: #475569;
          text-transform: uppercase; letter-spacing: 0.12em;
        }
        .ft-rating-badge {
          display: inline-flex; align-items: center; gap: 8px;
          background: #1e293b; border-radius: 40px;
          padding: 8px 18px;
        }
        .ft-stars { display: flex; gap: 4px; }

        /* Grid: 1 col mobile → 3 col desktop */
        .ft-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 24px;
          margin-bottom: 20px;
        }
        @media (min-width: 560px) {
          .ft-grid { grid-template-columns: repeat(3, 1fr); align-items: start; }
        }

        .ft-block {
          display: flex; flex-direction: column; gap: 10px;
          align-items: center; text-align: center;
        }
        @media (min-width: 560px) {
          .ft-block:nth-child(1) { align-items: flex-start; text-align: left; }
          .ft-block:nth-child(2) { align-items: center;     text-align: center; }
          .ft-block:nth-child(3) { align-items: flex-end;   text-align: right; }
        }

        .ft-block-title {
          font-size: 9px; font-weight: 700; color: #f59e0b;
          text-transform: uppercase; letter-spacing: 0.14em;
          padding-bottom: 6px; border-bottom: 1px solid #1e293b;
          width: 100%; text-align: inherit;
        }
        .ft-a {
          display: flex; align-items: center; gap: 7px;
          font-size: 13px; color: #94a3b8; text-decoration: none;
          transition: color 0.15s; white-space: nowrap;
        }
        .ft-a:hover { color: #e2e8f0; }
        .ft-a svg { flex-shrink: 0; }

        /* Social buttons — stile FooterPubblico */
        .ft-social-row {
          display: flex; gap: 10px;
        }
        .ft-social-btn {
          width: 40px; height: 40px; border-radius: 12px;
          display: flex; align-items: center; justify-content: center;
          text-decoration: none;
          background: rgba(255,255,255,0.04);
          border: 1px solid rgba(255,255,255,0.08);
          transition: background 0.2s, transform 0.15s, border-color 0.2s;
        }
        .ft-social-btn:hover {
          background: rgba(255,255,255,0.08);
          transform: translateY(-2px);
          border-color: rgba(255,255,255,0.15);
        }

        .ft-menu-btn {
          display: inline-block; padding: 7px 18px; border-radius: 20px;
          background: #f59e0b; color: #0f172a;
          font-size: 12px; font-weight: 700; text-decoration: none;
          transition: background 0.15s;
        }
        .ft-menu-btn:hover { background: #fbbf24; }

        .ft-copy {
          text-align: center; font-size: 10px; color: #334155;
          padding: 12px 20px;
          border-top: 1px solid #1e293b;
        }
      `}</style>

      <footer className="ft-root">
        <div className="ft-wrap">

          {/* ── Rating ── */}
          <div className="ft-rating">
            <span className="ft-rating-label">Valutazione clienti</span>
            {isLoading ? (
              <span style={{ fontSize: 12, color: "#334155" }}>Caricamento...</span>
            ) : (
              <div className="ft-rating-badge">
                <div className="ft-stars">
                  {[1,2,3,4,5].map(i => (
                    <FaStar key={i} size={16}
                      color={i <= Math.round(averageRating) ? "#f59e0b" : "#334155"} />
                  ))}
                </div>
                <span style={{ fontSize: 18, fontWeight: 700, color: "#fff" }}>
                  {averageRating.toFixed(1)}
                </span>
                <span style={{ fontSize: 11, color: "#475569" }}>{totalReviews} voti</span>
              </div>
            )}
          </div>

          {/* ── 3 colonne ── */}
          <div className="ft-grid">

            <div className="ft-block">
              <div className="ft-block-title">Contatti</div>
              <a href="tel:+393286872410" className="ft-a">
                <FaMobileAlt style={{ color: "#22c55e", fontSize: 14 }} />
                +39 328 687 2410
              </a>
              <a href="tel:+390964369497" className="ft-a">
                <FaPhoneAlt style={{ color: "#60a5fa", fontSize: 13 }} />
                +39 0964 369497
              </a>
            </div>

            <div className="ft-block">
              <div className="ft-block-title">Dove siamo</div>
              <span style={{ fontSize: 12, color: "#64748b", lineHeight: 1.6 }}>
                Via Europa 35, 89046<br />Marina di Gioiosa Ionica (RC)
              </span>
              <a href={mapsUrl} target="_blank" rel="noopener noreferrer"
                className="ft-a" style={{ color: "#f59e0b" }}>
                <FaMapMarkerAlt size={13} /> Visualizza mappa
              </a>
            </div>

            <div className="ft-block">
              <div className="ft-block-title">Condividi</div>
              <div className="ft-social-row">
                <a href={menuUrl} target="_blank" rel="noopener noreferrer"
                  className="ft-social-btn" title="Visualizza menu">
                  <span style={{ fontSize: 11, fontWeight: 700, color: "#f59e0b" }}>MENU</span>
                </a>
                <a href={whatsappUrl} target="_blank" rel="noopener noreferrer"
                  className="ft-social-btn" title="Condividi su WhatsApp">
                  <FaWhatsapp size={18} style={{ color: "#22c55e" }} />
                </a>
              </div>
            </div>

          </div>
        </div>

        <div className="ft-copy">
          © {new Date().getFullYear()} Nuovo Forno dal 1966, di Matteo Lupis — P.IVA 03242870800
        </div>
      </footer>
    </>
  );
};

export default Footer;